import {
    CheckIcon,
    HeartIcon,
    InternalGrid,
    Title,
} from '@paygreen/paygreen-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ProjectName = (props) => {
    const {
        project: {
            name,
            isDefault,
            isUserProject,
            isUserDefaultProject = null,
        },
        userProjects,
    } = props;

    const { t } = useTranslation();

    const renderHeartIcon = () => {
        if (
            (isUserDefaultProject && isUserProject) ||
            (isDefault === '1' && userProjects)
        ) {
            return <HeartIcon title={renderToltipTitle()} iconSize="md" />;
        }
        return null;
    };

    const renderCheckIcon = () => {
        if (isUserProject && !isUserDefaultProject) {
            return <CheckIcon title={renderToltipTitle()} iconSize="md" />;
        }
        return null;
    };

    const renderToltipTitle = () => {
        if ((isDefault === '1' && userProjects) || isUserDefaultProject) {
            return `${name} ${t(
                'contributions.globalView.globalCard.isFavorite',
            )}`;
        }

        if ((isDefault === '0' && userProjects) || isUserProject) {
            return `${name} ${t(
                'contributions.globalView.globalCard.isMyProject',
            )}`;
        }

        return null;
    };

    return (
        <>
            <InternalGrid
                alignItems="center"
                flexWrap="nowrap"
                justifyContent="center"
            >
                <Title
                    marginLateral={'xs'}
                    textSize="md"
                    align="center"
                    colorWab="grey40"
                    style={{ maxWidth: '70%' }}
                    colorPallet={
                        isUserDefaultProject || isUserProject ? 'theme' : 'wab'
                    }
                >
                    {name}
                </Title>
                {renderCheckIcon()}

                {renderHeartIcon()}
            </InternalGrid>
        </>
    );
};

export default ProjectName;
